<div class="static-text">
    <span>{{ normalizedLabel }}</span>
    <span *ngIf="value === null" class="static-text__value">NULL</span>
    <span *ngIf="value" class="static-text__value">{{ value }}</span>
</div>

